import React from 'react'
import { useShared } from '../../../../contexts/shared.context';
import { useNavigate, useParams } from 'react-router-dom';
import classes from './styles.module.scss';
import { MenuCloseIcon } from '../../../../assets/icons';



const FullscreenClose = () => {
    const { setFullscreen } = useShared();
    const navigate = useNavigate();
    const { tab, type } = useParams<{ tab: string, type: string}>();

    return (
        <span className={classes['fullscreen__close']} onClick={() => {
            if (tab) {
                const url = new URL(window.location.href);
                url.pathname = url.pathname.replace(`/${type}`, '');
                navigate(url.pathname, { replace: true });
            }
            setFullscreen({
                open: false,
                type: null
            })

        }}>
            <MenuCloseIcon />
        </span >
    )
}

export default FullscreenClose